import Vue from "vue"
import VueRouter from "vue-router"
// import HelloWorld from '../components/HelloWorld.vue'


import login from '../views/login.vue'
import home from '../views/home.vue'
import market from '../views/market.vue'
import count from '../views/count.vue'
import visit from '../views/visit.vue'
import done_visit from '../views/done_visit.vue'
import checklist from '../views/checklist.vue'
import done_checklist from '../views/done_checklist.vue'
import register from '../views/register.vue'
import delete_req from '../views/delete.vue'
// import paper from '../views/paper.vue'

import firebase from 'firebase/app';

Vue.use(VueRouter)

const routes = [
	{
		path: "/",
		name: "home",
		component: home,
		meta: { requiresAuth: true },
	},
	// {
	// 	path: "/paper",
	// 	name: "paper",
	// 	component: paper,
	// 	meta: { requiresAuth: false },
	// },
	{
		path: "/login",
		name: "login",
		component: login,
		meta: { requiresAuth: false }
	},
	{
		path: "/register",
		name: "register",
		component: register,
		meta: { requiresAuth: false }
	},
	{
		path: "/delete",
		name: "delete",
		component: delete_req,
		meta: { requiresAuth: false }
	},
	{ 
		path: '/market/:market_id',
		component: market,
		meta: { requiresAuth: true },
		name: "market"
	},
	{ 
		path: '/count/:market_id/:visit_id/:craft',
		component: count,
		meta: { requiresAuth: true },
		name: "count"
	},
	{ 
		path: '/visit/:market_id/:visit_id',
		component: visit,
		meta: { requiresAuth: true },
		name: "visit"
	},
	{ 
		path: '/done_visit/:market_id/:visit_id',
		component: done_visit,
		meta: { requiresAuth: true },
		name: "done_visit"
	},
	{ 
		path: '/checklist/:market_id/:visit_id/:checklist_id',
		component: checklist,
		meta: { requiresAuth: true },
		name: "checklist"
	},
	{ 
		path: '/done_checklist/:market_id/:visit_id/:checklist_id',
		component: done_checklist,
		meta: { requiresAuth: true },
		name: "done_checklist"
	}
]

const router = new VueRouter({
	routes
})

router.beforeEach((to, from, next) => {
	if (to.matched.some(record => record.meta.requiresAuth)) {
		firebase.auth().onAuthStateChanged((user) => {
			if(!user && to.name === "done_visit" && to.params.market_id && to.params.visit_id) {
				next( { path: '/login', query: { market_id: to.params.market_id, visit_id: to.params.visit_id }} )
			}
			else if (!user) {
				next({ path: '/login' }) 
			}
			else { next() }
		})
	}
	else if (!to.matched.some(record => record.meta.requiresAuth)) {
		firebase.auth().onAuthStateChanged((user) => {
			if(user && to.name ==='login' && to.query.visit_id && to.query.market_id){
				next({path: '/done_visit/' + to.query.market_id + '/' + to.query.visit_id})
			}
			else if (user && to.name ==='login') { next({ path: '/' }) }
			else { next() }
		})
	}
	else { next() }
});

export default router